module.exports = __webpack_public_path__ + "static/media/harsh@3x.491a5563.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/team/harsh@3x.png
// module id = 217
// module chunks = 1